/** Reusable KPI stat card used across Dashboard and (later) other modules. */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../theme/theme';

interface StatCardProps {
  icon: React.ReactElement;
  /** Accent color (icon tint + soft bg). */
  color: string;
  value: React.ReactNode;
  label: string;
  /** Small trend/affordance text top-right (e.g. "+12%" or "View →"). */
  trend?: React.ReactNode;
  trendColor?: string;
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({ icon, color, value, label, trend, trendColor, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      p: 2.25,
      borderRadius: '14px',
      bgcolor: colors.backgroundPaper,
      border: `1px solid ${colors.border}`,
      cursor: onClick ? 'pointer' : 'default',
      transition: 'box-shadow .15s, transform .15s, border-color .15s',
      ...(onClick && {
        '&:hover': { boxShadow: '0 6px 18px rgba(15,23,42,.08)', transform: 'translateY(-2px)', borderColor: colors.primaryLight },
      }),
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ width: 42, height: 42, borderRadius: '12px', display: 'grid', placeItems: 'center', bgcolor: `${color}22`, color }}>
        {icon}
      </Box>
      {trend != null && (
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: trendColor || colors.success, display: 'flex', alignItems: 'center', gap: 0.25 }}>
          {trend}
        </Typography>
      )}
    </Box>
    <Typography sx={{ fontSize: 28, fontWeight: 800, mt: 1.5, letterSpacing: '-.5px', lineHeight: 1.1 }}>{value}</Typography>
    <Typography sx={{ color: colors.textSecondary, fontSize: 13 }}>{label}</Typography>
  </Box>
);

export default StatCard;
